// Footer.jsx



// Footer.jsx
import { Box, Typography, Grid, Link, Divider } from '@mui/material';
import FooterStyles from './Footer.styles';

const Footer = () => {
  return (
    <Box component="footer" sx={FooterStyles.footerContainer}>
      <Grid container spacing={4} justifyContent="center">
        {/* Company Info */}
        <Grid item xs={12} sm={4}>

          <Typography variant="h6" sx={FooterStyles.sectionTitle}>
            About Tenant Access
          </Typography>
          <Typography variant="body2" sx={FooterStyles.sectionText}>
            Making property management and automated rental showings keyless
          </Typography>

             {/* Logo from /public/logo-new.png */}
          <Box sx={{ mb: 1 }}>
            <img 
              src="/logo-new.png"  // 👈 path relative to public folder
              alt="Tenant Access" 
              style={{ maxWidth: "240px", height: "auto" }} 
            />
          </Box>
        </Grid>

        {/* Quick Links */}
        <Grid item xs={12} sm={4}>
          <Typography variant="h6" sx={FooterStyles.sectionTitle}>
            Quick Links
          </Typography>
          <Box sx={FooterStyles.linksContainer}>
            <Link href="https://mytenantaccess.com" sx={FooterStyles.link}>Home</Link>
            {/* <Link href="/about" sx={FooterStyles.link}>About Us</Link> */}
            <Link href="/terms-and-conditions" sx={FooterStyles.link}>Terms</Link>
            <Link href="https://mytenantaccess.com/privacy-policy/" sx={FooterStyles.link}>Privacy</Link>
          </Box>
        </Grid>

        {/* Social Media */}
    
      </Grid>

      {/* Divider */}
      <Divider sx={FooterStyles.divider} />

      {/* Footer Bottom */}
      <Box sx={FooterStyles.bottomContainer}>
        <Typography variant="body2">
          © {new Date().getFullYear()} Tenant Access. All rights reserved.
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
